import { createContext, useContext } from 'react';
export const RecordPermissionsContext = /*#__PURE__*/createContext(undefined);
export const useRecordPermissions = () => {
  const permissions = useContext(RecordPermissionsContext);
  if (permissions === undefined) {
    throw new Error('RecordPermissionsContext has not been set');
  }
  const {
    currentUserCanView,
    currentUserCanCreate,
    currentUserCanEdit,
    currentUserCanCommunicate,
    currentUserCanDelete,
    currentUserCanMerge
  } = permissions;
  return {
    currentUserCanView,
    currentUserCanCreate,
    currentUserCanEdit,
    currentUserCanCommunicate,
    currentUserCanDelete,
    currentUserCanMerge
  };
};